import { LocalDate } from '../../../../shared/jsr310-localdates/types/local-date.type';

export class AccesSearchCriteria {
	numeroAcces!: string;
	agence?: number;
	antenne?: number;
	groupement?: number;
	parc?: number;
	ouvrages!: number[];
	uniteCritereDate: string = 'JOURS';
	critereDate: number = 7;
	dateMin: LocalDate | null = null;
	dateMax: LocalDate | null = null;
	etat!: number;
	technologies?: number[];
	typeMaintenances?: number[];
	types?: number[];
	monPerimetreCac!: boolean;
	monPerimetreCc!: boolean;
	monPerimetreReferent!: boolean;
	entreprise?: number;
	valideur?: number;
	demandeFermeture!: boolean;
	coactivitePilotageEco: boolean = false;
	masquerPilotageEco: boolean = false;
	onlyTarifNegatifs: boolean = false;
}